<script>
export default {
  name: "enrollmentHU.vue",

  props: {
    questionsData: {
      type: Object,
      required: true,
      default: {},
    },
    modelValue: {
      type: Object,
      required: true,
      default: {
        "HU Question #1":"null",
        "HU Question #2":"null",
        "HU Question #3":{
          "American Indian or Alaska Native":"null",
          "Asian":"null",
          "Black or African American":"null",
          "Native Hawaiian or Other Pacific Islander":"null",
          "White":"null"
        },
        "HU Question #4":"null",
        "HU Question #5":"null",
        "HU Question #6":"null",
        "HU Question #7":"null"
      },
    }
  },

  data() {
    return {
      showContent: true,
      editableClassesSelect: 'bg-primary italic rounded border border-grey-lighter w-full py-2 px-3 leading-tight focus:outline-none focus:ring',
    }
  },

  computed: {
    modelValue: {
      get() {
        return this.modelValue ?? this.modelValue.default;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  },

  methods: {
    toggleContent() {
      this.showContent = !this.showContent;
    },
  }
}
</script>

<template>
  <div class="flex flex-col flex-wrap flex-1 my-1">
    <div class="font-semibold flex flex-col bg-secondary italic rounded tile-shadow leading-tight focus:outline-none focus:ring">
      <button type="button" @click="toggleContent"
        class="font-semibold hover:text-blue py-2">
        <div v-show="!this.showContent">
          <i class="fas fa-caret-right ml-2"></i><span class="mx-2">Click To Expand </span>
        </div>
        <div v-show="this.showContent">
          <i class="fas fa-caret-down ml-2"></i><span class="mx-2">Click To Hide</span>
        </div>
      </button>
      <div v-show="this.showContent" class="m-2">
        <div class="p-2" v-html="questionsData.info"/>
        <div class="p-2">
          <div v-for="question in this.questionsData.questions" class="mb-2">
            <label :for="question.id" v-html="question.question"></label>
            <div v-if="question.multiple" v-for="option in question.options" class="mt-1">
              <input type="checkbox" :name="option" :value="option" v-model="this.modelValue[question.label][option]"/>
              <label :for="option" class="ml-1 my-1">{{ option }}</label>
            </div>
            <div v-else>
              <select :name="question.label" :id="question.label" v-model="this.modelValue[question.label]"
                      :class="editableClassesSelect">
                <option :value="null">
                  Select...
                </option>
                <option v-for="option in question.options" :value="option">
                  {{ option }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
